export const SEARCH_IMAGE_REQUEST = "SEARCH_IMAGE_REQUEST";
export const SEARCH_IMAGE_SUCCESS = "SEARCH_IMAGE_SUCCESS";
export const SEARCH_IMAGE_FAILURE = "SEARCH_IMAGE_FAILURE";

export const GET_RANDOM_IMAGE_REQUEST = "GET_RANDOM_IMAGE_REQUEST";
export const GET_RANDOM_IMAGE_SUCCESS = "GET_RANDOM_IMAGE_SUCCESS";
export const GET_RANDOM_IMAGE_FAILURE = "GET_RANDOM_IMAGE_FAILURE";

export const SEARCH_IMAGE_PAGINATION_REQUEST =
  "SEARCH_IMAGE_PAGINATION_REQUEST";
export const SEARCH_IMAGE_PAGINATION_SUCCESS =
  "SEARCH_IMAGE_PAGINATION_SUCCESS";
export const SEARCH_IMAGE_PAGINATION_FAILURE =
  "SEARCH_IMAGE_PAGINATION_FAILURE";

export const GET_RANDOM_IMAGE_PAGINATION_REQUEST =
  "GET_RANDOM_IMAGE_PAGINATION_REQUEST";
export const GET_RANDOM_IMAGE_PAGINATION_SUCCESS =
  "GET_RANDOM_IMAGE_PAGINATION_SUCCESS";
export const GET_RANDOM_IMAGE_PAGINATION_FAILURE =
  "GET_RANDOM_IMAGE_PAGINATION_FAILURE";

export const RESET_PAGES = "RESET_PAGES";

export const UPDATE_SEARCH_TEXT = "UPDATE_SEARCH_TEXT";
